import { Goal, ID } from '@griply/types';

import { getArchivedGoalIds } from './derived-goal-state';
import { buildGoalTree, GoalTreeNode } from './goals/build-goal-tree';
import { sortGoals } from './sort-goals';

// Completed goals stay selectable — their tasks must remain findable via the goal filter.
export const buildGoalFilterOptionTree = (
  goals: Goal[],
  taskCounts?: Map<ID, number>,
): GoalTreeNode[] => {
  const archivedIds = getArchivedGoalIds(goals);
  const candidates = goals.filter(
    (goal) => !archivedIds.has(goal.id) && !goal.frozenAt,
  );

  const sortChildren = (
    nodes: GoalTreeNode[],
    parent: Goal,
  ): GoalTreeNode[] => {
    const order = new Map(
      sortGoals(
        nodes.map(({ goal }) => goal),
        {
          allGoals: candidates,
          sortMode: parent.goalSortingMode,
          customOrder: parent.goalSorting,
          taskCounts,
        },
      ).map((goal, index) => [goal.id, index]),
    );

    return nodes
      .slice()
      .sort((a, b) => (order.get(a.goal.id) ?? 0) - (order.get(b.goal.id) ?? 0))
      .map((node) => ({
        goal: node.goal,
        children: sortChildren(node.children, node.goal),
      }));
  };

  return buildGoalTree(candidates).map((node) => ({
    goal: node.goal,
    children: sortChildren(node.children, node.goal),
  }));
};
